import { all } from "redux-saga/effects";
import { AnyAction, Reducer, combineReducers } from "redux";
import * as auth from "app/modules/auth/redux/AuthRedux";
import companyProviderReducer from "app/modules/system/whiteLabelling/CompanyProviderSlice";
import loginReducer from "app/modules/auth/login/components/LoginPageSlice";
import termsAndConditionsReducer from "app/modules/auth/termsandconditions/TermsAndConditionsSlice";
import twoFactorAuthenticationReducer from "app/modules/auth/twofactorauthentication/TwoFactorAuthenticationSlice";
import registrationReducer from "app/modules/auth/registration/components/RegistrationPageSlice";
import userProfileReducer from "app/modules/account/components/cards/components/UserProfileSlice";
import companyBrandingReducer from "app/modules/system/whiteLabelling/CompanyBrandingSlice";
import addAccountReducer from "app/pages/accounts/add-account/components/AddAccountSlice";
import signalRAlertsReducer from "signalR/Notifications/SignalRAlertSlice";
import signalRProgressReducer from "signalR/Notifications/SignalRProgressBarSlice";
import maintenanceReducer from "app/system/maintenance/MaintenanceSlice";
import errorAlertReducer from "app/system/errors/ServerErrorAlertSlice";
import overallAccountsBalanceReducer from "app/pages/accounts/overallAccountBalance/components/OverallAccountsBalanceSlice";
import propertyBalancesTableReducer from "app/pages/accounts/propertyBalancesTable/components/PropertyBalancesTableSlice";
import clientTransactionsTableReducer from "app/pages/accounts/clientTransactionsTable/components/ClientTransactionsTableSlice";
import transactionInvoicesTableReducer from "app/pages/accounts/transactionInvoicesTable/components/TransactionInvoicesTableSlice";
import jobsTableReducer from "app/modules/jobs/components/JobsTableSlice";
import jobDetailsReducer from "app/modules/jobs/components/JobDetailsSlice";
import commentThreadReducer from "app/modules/shared/commentThread/components/CommentThreadSlice";
import casesTableReducer from "app/modules/cases/components/CasesTableSlice";
import caseDetailsReducer from "app/modules/cases/components/CaseDetailsSlice";
import propertySelectReducer from "app/modules/shared/selectComponents/propertySelect/components/PropertySelectSlice";
import caseTypeSelectReducer from "app/modules/shared/selectComponents/caseTypeSelect/components/CaseTypeSelectSlice";
import accountLinkingBannerReducer from "app/modules/system/banners/accountLinking/AccountLinkingBannerSlice";
import forgotPasswordPageReducer from "app/modules/auth/forgotPassword/components/ForgotPasswordPageSlice";
import resetPasswordReducer from "app/modules/auth/resetPassword/ResetPasswordSlice";
import proposedWorksTableReducer from "app/modules/proposedWorks/components/ProposedWorksTableSlice";
import proposedWorksDetailReducer from "app/modules/proposedWorks/components/ProposedWorksDetailSlice";
import documentsTableReducer from "app/modules/documents/components/DocumentsTableSlice";
import CreditControlDevelopmentSummariesReducer from "app/modules/creditControl/components/CreditControlDevelopmentSummariesTableSlice";
import CreditControlStatusSummariesReducer from "app/modules/creditControl/components/CreditControlStatusSummariesTableSlice";
import CreditControlUnitSummariesReducer from "app/modules/creditControl/components/CreditControlUnitSummariesTableSlice";
import payNowReducer from "app/modules/payments/components/PayNowPageSlice";
import meetingsTableReducer from "app/modules/meetings/components/MeetingsTableSlice";
import meetingDetailsReducer from "app/modules/meetings/components/MeetingDetailsSlice";
import meetingTypesSelectReducer from "app/modules/shared/selectComponents/meetingTypeSelect/components/MeetingTypeSelectSlice";
import globalSearchReducer from "app/modules/shared/globalSearch/components/GlobalSearchSlice";
import newsReducer from "app/modules/developments/news/DevelopmentNewsSlice";
import linkedAccountsReducer from "app/modules/account/components/cards/ClientContactDetails/components/LinkedAccountsSlice";
import clientContactDetailsReducer from "app/modules/account/components/cards/ClientContactDetails/components/ContactDetailsSlice";
import developmentInfoReducer from "app/modules/developments/DevelopmentInfoSlice";
import apiStatusReducer from "app/system/apiStatus/APIStatusSlice";
import externalAccessReducer from "app/modules/shared/externalAccess/ExternalAccessSlice";
import newsPostReducer from "app/modules/developments/news/DevelopmentNewsPostSlice";
import clientEmailAddressesReducer from "app/modules/account/components/cards/ClientContactDetails/components/clientEmailAddresses/ClientEmailAddressesSlice";
import clientAddressesReducer from "app/modules/account/components/cards/ClientContactDetails/components/clientAddresses/ClientAddressesSlice";
import webNarrativeReducer from "app/modules/shared/webNarrative/components/WebNarrativeSlice";
import clientPortalSettingsReducer from "app/modules/system/settings/ClientPortalSettingsSlice";
import asideMenuReducer from "app/modules/navigation/aside/AsideMenuSlice";
import CookiePreferencesReducer from "app/system/cookies/CookiePreferencesSlice";
import errorHandlerReducer from "app/modules/errors/ErrorHandlerSlice";
import dashboardIntroductionMessageReducer from "app/pages/dashboard/DashboardIntroductionMessage/DashboardIntroductionMessageSlice";
import clientBudgetsTableReducer from "app/modules/budgets/components/ClientBudgetsTableSlice";
import clientBudgetHeadersTableReducer from "app/modules/budgets/components/ClientBudgetHeadersTableSlice";
import clientBudgetHeaderChargesTableReducer from "app/modules/budgets/components/ClientBudgetHeaderChargesTableSlice";
import impersonationReducer from "app/modules/auth/impersonation/components/ImpersonationSlice";

const combinedReducer = combineReducers({
  auth: auth.reducer,
  login: loginReducer,
  registration: registrationReducer,
  companyProvider: companyProviderReducer,
  termsAndConditions: termsAndConditionsReducer,
  twoFactorAuthentication: twoFactorAuthenticationReducer,
  userProfile: userProfileReducer,
  companyBranding: companyBrandingReducer,
  addAccount: addAccountReducer,
  signalRAlerts: signalRAlertsReducer,
  signalRProgress: signalRProgressReducer,
  maintenance: maintenanceReducer,
  errorAlert: errorAlertReducer,
  overallAccountsBalance: overallAccountsBalanceReducer,
  propertyBalancesTable: propertyBalancesTableReducer,
  clientTransactionsTable: clientTransactionsTableReducer,
  transactionInvoicesTable: transactionInvoicesTableReducer,
  jobsTable: jobsTableReducer,
  jobDetails: jobDetailsReducer,
  commentThread: commentThreadReducer,
  casesTable: casesTableReducer,
  caseDetails: caseDetailsReducer,
  propertySelect: propertySelectReducer,
  caseTypeSelect: caseTypeSelectReducer,
  accountLinkingBanner: accountLinkingBannerReducer,
  forgotPassword: forgotPasswordPageReducer,
  resetPassword: resetPasswordReducer,
  proposedWorksTable: proposedWorksTableReducer,
  proposedWorksDetail: proposedWorksDetailReducer,
  documentsTable: documentsTableReducer,
  CreditControlDevelopmentSummaries: CreditControlDevelopmentSummariesReducer,
  CreditControlStatusSummaries: CreditControlStatusSummariesReducer,
  CreditControlUnitSummaries: CreditControlUnitSummariesReducer,
  payNow: payNowReducer,
  meetingsTable: meetingsTableReducer,
  meetingDetails: meetingDetailsReducer,
  meetingTypes: meetingTypesSelectReducer,
  globalSearch: globalSearchReducer,
  news: newsReducer,
  linkedAccounts: linkedAccountsReducer,
  clientContactDetails: clientContactDetailsReducer,
  developmentInfo: developmentInfoReducer,
  apiStatus: apiStatusReducer,
  externalAccess: externalAccessReducer,
  newsPost: newsPostReducer,
  clientEmailAddresses: clientEmailAddressesReducer,
  clientAddresses: clientAddressesReducer,
  webNarrative: webNarrativeReducer,
  clientPortalSettings: clientPortalSettingsReducer,
  asideMenu: asideMenuReducer,
  cookiePreferences: CookiePreferencesReducer,
  errorHandler: errorHandlerReducer,
  dashboardIntroductionMessage: dashboardIntroductionMessageReducer,
  clientBudgetsTable: clientBudgetsTableReducer,
  clientBudgetHeadersTable: clientBudgetHeadersTableReducer,
  clientBudgetHeaderChargesTable: clientBudgetHeaderChargesTableReducer,
  impersonation: impersonationReducer,
});

export const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === auth.actionTypes.Logout || action.type === auth.actionTypes.ResetContentState) {
    // These are intentionally left in the state on logout
    // For more information, see login-flow.md
    state = {
      companyProvider: state.companyProvider,
      companyBranding: state.companyBranding,
      asideMenu: state.asideMenu,
      auth: state.auth,
      impersonation: state.impersonation,
    } as RootState;
  }
  return combinedReducer(state, action);
};

export type RootState = ReturnType<typeof combinedReducer>;

export function* rootSaga() {
  yield all([auth.saga()]);
}
